import * as actionTypes from '../../action/commentslist/CommentsList'

const initialState = {
    error: false,
    isFetching: false,
    errormessage: '',
}

const reducer = (state = initialState, action) => {
    switch ( action.type ){
        case actionTypes.GET_COMMENTS_FETCH:
            return {
                ...state,
                commentFetching: true
            };
        case actionTypes.GET_COMMENTS_SUCCESS :
            return {
                ...state,
                commentFetching: false,
                error: false,
                commentlist: action.payload
            };
        
        case actionTypes.GET_COMMENTS_FAILURE :
            return {
                ...state,
                commentFetching: false,
                error: action.payload
            };
        
        case actionTypes.GET_COMMENTS_MESSAGE:
            return {
                ...state,
                commentFetching: false,
                error: false,
                errormessage: action.payload
            };
        
        default:
            return state;
    }
}

export default reducer;